import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingHeader from "@/components/landing/LandingHeader";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Pillars from "@/components/landing/Pillars";
import Mentorship from "@/components/landing/Mentorship";
import Footer from "@/components/landing/Footer";
import Admin from "@/pages/Admin";

function Landing() {
  return (
    <>
      <LandingHeader />
      <main>
        <Hero />
        <Marquee />
        <Pillars />
        <Mentorship />
      </main>
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App overflow-x-clip bg-[#0D0D0D] text-white" data-testid="app-root">
      <div className="noise-overlay" aria-hidden="true" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "#141414",
            border: "1px solid rgba(212,175,55,0.35)",
            color: "#ffffff",
          },
        }}
      />
    </div>
  );
}

export default App;
